// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/fonts/RoobertPRO-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/fonts/RoobertPRO-Medium.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/fonts/RoobertPRO-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M14 8C14 8.13261 13.9473 8.25979 13.8536 8.35355C13.7598 8.44732 13.6326 8.5 13.5 8.5H8.5V13.5C8.5 13.6326 8.44732 13.7598 8.35355 13.8536C8.25979 13.9473 8.13261 14 8 14C7.86739 14 7.74021 13.9473 7.64645 13.8536C7.55268 13.7598 7.5 13.6326 7.5 13.5V8.5H2.5C2.36739 8.5 2.24021 8.44732 2.14645 8.35355C2.05268 8.25979 2 8.13261 2 8C2 7.86739 2.05268 7.74021 2.14645 7.64645C2.24021 7.55268 2.36739 7.5 2.5 7.5H7.5V2.5C7.5 2.36739 7.55268 2.24021 7.64645 2.14645C7.74021 2.05268 7.86739 2 8 2C8.13261 2 8.25979 2.05268 8.35355 2.14645C8.44732 2.24021 8.5 2.36739 8.5 2.5V7.5H13.5C13.6326 7.5 13.7598 7.55268 13.8536 7.64645C13.9473 7.74021 14 7.86739 14 8Z%27 fill=%27%238DABF7%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg width=%2721%27 height=%2720%27 viewBox=%270 0 21 20%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M18 10C18 10.1658 17.9342 10.3247 17.8169 10.4419C17.6997 10.5592 17.5408 10.625 17.375 10.625H11.125V16.875C11.125 17.0408 11.0592 17.1997 10.9419 17.3169C10.8247 17.4342 10.6658 17.5 10.5 17.5C10.3342 17.5 10.1753 17.4342 10.0581 17.3169C9.94085 17.1997 9.875 17.0408 9.875 16.875V10.625H3.625C3.45924 10.625 3.30027 10.5592 3.18306 10.4419C3.06585 10.3247 3 10.1658 3 10C3 9.83424 3.06585 9.67527 3.18306 9.55806C3.30027 9.44085 3.45924 9.375 3.625 9.375H9.875V3.125C9.875 2.95924 9.94085 2.80027 10.0581 2.68306C10.1753 2.56585 10.3342 2.5 10.5 2.5C10.6658 2.5 10.8247 2.56585 10.9419 2.68306C11.0592 2.80027 11.125 2.95924 11.125 3.125V9.375H17.375C17.5408 9.375 17.6997 9.44085 17.8169 9.55806C17.9342 9.67527 18 9.83424 18 10Z%27 fill=%27%238DABF7%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Primitives */
  --clr-dark-blue-300: hsla(218, 48%, 17%, 1);
  --clr-dark-blue-400: hsla(218, 47%, 13%, 1);
  --clr-dark-blue-500: hsla(218, 48%, 10%, 1);
  --clr-dark-blue-700: hsla(215, 50%, 5%, 1);
  --clr-light-blue-400: hsla(223, 87%, 76%, 1);
  --clr-yellow-400: hsla(58, 99%, 72%, 1);
  --clr-red-400: hsla(0, 68%, 60%, 1);
  --clr-accent-brand: hsla(241, 61%, 55%, 1);

  /* Background */
  --clr-bg-primary: var(--clr-dark-blue-400);
  --clr-bg-secondary: var(--clr-dark-blue-300);
  --clr-bg-overlay: var(--clr-dark-blue-700);
  --clr-bg-overlay-2: hsla(0, 0%, 0%, 0.5);
  --clr-bg-sidebar: hsla(218, 48%, 10%, 1);
  --clr-bg-btn-primary: var(--clr-accent-brand);

  /* Text */
  --clr-text-primary: hsla(0, 0%, 100%, 1);
  --clr-text-secondary: hsla(0, 0%, 65%, 1);
  --clr-text-tertiary: hsla(0, 0%, 41%, 1);
  --clr-text-light-blue: var(--clr-light-blue-400);

  /* Divider */
  --clr-divider: hsla(217, 29%, 15%, 1);

  /* List marker colors */
  --clr-list-green: hsla(115, 63%, 77%, 1);
  --clr-list-blue: hsla(209, 86%, 71%, 1);
  --clr-list-pink: hsla(320, 94%, 73%, 1);
  --clr-list-purple: hsla(265, 38%, 58%, 1);
  --clr-list-orange: hsla(25, 89%, 60%, 1);
  --clr-list-mint: hsla(173, 96%, 82%, 1);

  /* Font sizes */
  --fs-h1: clamp(1.5rem, 1.3269rem + 0.7692vw, 1.875rem);
  --fs-body: clamp(0.875rem, 0.8173rem + 0.2564vw, 1rem);
}

/* Mini reset */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  -moz-text-size-adjust: none;
  -webkit-text-size-adjust: none;
  text-size-adjust: none;
}

body,
h1,
h2,
h3,
h4,
p,
figure,
blockquote,
dl,
dd {
  margin-block-end: 0;
}

ul {
  list-style: none;
}

body {
  min-height: 100vh;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  font-size-adjust: 0.52;
}

h1,
h2,
h3,
h4,
button,
input,
label {
  line-height: 1.1;
}

h1,
h2,
h3,
h4 {
  text-wrap: balance;
}

p {
  text-wrap: pretty;
  margin: 0;
}

p,
h1,
h2,
h3,
h4,
h5,
h6 {
  overflow-wrap: break-word;
}

ul {
  padding: 0;
  margin: 0;
}

img,
picture {
  max-width: 100%;
  display: block;
}

button {
  border: none;
  cursor: pointer;
  background-color: transparent;
  padding: 0;
}

input,
button,
textarea,
select {
  font-family: inherit;
  font-size: inherit;
}

:target {
  scroll-margin-block: 5ex;
}

@media (prefers-reduced-motion: no-preference) {
  html {
    interpolate-size: allow-keywords;
  }
}
/* Mini reset end */

/* Custom fonts */
@font-face {
  font-family: 'Roobert PRO';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff2');
  font-weight: 400;
  font-style: normal;
  font-display: block;
}

@font-face {
  font-family: 'Roobert PRO';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff2');
  font-weight: 500;
  font-style: normal;
  font-display: block;
}

@font-face {
  font-family: 'Roobert PRO';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2');
  font-weight: 700;
  font-style: normal;
  font-display: block;
}

/* Styles */
body {
  font-family: 'Roobert PRO', sans-serif;
  background-color: var(--clr-bg-primary);
  text-rendering: optimizeSpeed;
  line-height: 1.5;
}

body:has(.sidebar.visible) {
  pointer-events: none;
}

#content {
  min-height: 100svh;
}

#content:has(dialog) {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

h1 {
  font-size: var(--fs-h1);
}

p,
button {
  font-size: var(--fs-body);
}

h1,
h2,
h3,
h4 {
  margin: 0;
  padding: 0;
  color: var(--clr-text-primary);
}

h3 {
  font-size: 1.25rem;
  font-weight: 700;
}

#list-title {
  color: var(--clr-text-light-blue);
  font-size: clamp(1.875rem, 1.4712rem + 1.7949vw, 2.75rem);
  font-weight: 700;
}

#todays-date {
  font-size: clamp(1rem, 0.9423rem + 0.2564vw, 1.125rem);
  color: var(--clr-text-secondary);
  margin-top: 0.5rem;
}

.sidebar {
  width: 18.375rem;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0;
  z-index: 100;
  transform: translateX(-60rem);
  transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);

  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  background-color: var(--clr-bg-sidebar);
  border-radius: 0 1rem 1rem 0;
  border-top: 1px solid var(--clr-divider, #1c2533);
  border-right: 1px solid var(--clr-divider, #1c2533);
  border-bottom: 1px solid var(--clr-divider, #1c2533);

  &.visible {
    transform: translateX(0);
  }

  .greeting {
    display: flex;
    align-items: center;
    gap: 0.75rem;

    img {
      width: 2rem;
      height: 2rem;
    }
  }

  ul {
    display: flex;
    flex-direction: column;

    > li button {
      padding: 0.75rem;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 3rem;
      color: var(--clr-text-secondary);
      border-radius: 0.625rem;

      > div {
        display: flex;
        align-items: center;
        gap: 0.75rem;

        svg {
          fill: var(--clr-text-secondary);
        }

        p {
          font-size: 1rem;
        }
      }

      span {
        font-size: 0.875rem;
      }

      &.active {
        background-color: var(--clr-bg-secondary);
        color: var(--clr-text-light-blue);

        p {
          font-weight: 500;
        }

        svg {
          fill: var(--clr-text-light-blue);
        }
      }
    }
  }

  .custom-list {
    h3 {
      margin-bottom: 0.75rem;
    }

    svg {
      fill: none;
    }

    button.active svg {
      fill: none;
    }

    > ul li:first-child button > div svg {
      stroke: var(--clr-list-green);
    }

    > ul li:nth-child(2) button > div svg {
      stroke: var(--clr-list-blue);
    }

    > ul li:nth-child(3) button > div svg {
      stroke: var(--clr-list-pink);
    }

    .btn-add-list {
      display: flex;
      align-items: center;
      gap: 0.75rem;
      margin-top: 0.5rem;
      padding-block: 0.75rem;
      width: 100%;
      opacity: 1;
      transition: all 0.4s ease-out;

      span {
        color: var(--clr-text-primary);
        transition: color 0.4s ease;
      }

      &:hover span {
        color: var(--clr-text-secondary);
      }

      &.hidden {
        opacity: 0;
        /* transform: translateY(-5rem);
        position: absolute; */
        display: none;
      }
    }

    #form-custom-list {
      margin-top: 0.5rem;
      padding-block: 0.75rem;
      display: flex;
      align-items: end;
      justify-content: space-between;
      gap: 0.75rem;

      > div {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        label {
          font-size: 0.825rem;
          color: var(--clr-text-secondary);
        }

        input {
          border-radius: 0.325rem;
          padding: 0.6rem;
          width: 100%;
          background-color: var(--clr-bg-secondary);
          color: var(--clr-text-primary);
          border: none;
        }
      }

      button {
        padding: 0.6rem 0.75rem;
        border-radius: 0.325rem;
        background-color: var(--clr-accent-brand);
        color: var(--clr-text-primary);
      }
    }
  }
}

.sidebar.visible,
.sidebar.visible *,
.sidebar.visible button,
.sidebar.visible a {
  pointer-events: auto !important;
}

.main {
  margin-top: 1.5rem;
  padding: 0 1rem;
}

dialog {
  padding: 1.25rem;
  background-color: var(--clr-bg-primary);
  border: 1px solid var(--clr-divider);
  border-radius: 1.5rem;

  > * {
    color: var(--clr-text-primary);
  }

  &::backdrop {
    background-color: var(--clr-bg-overlay);
  }
}

dialog#modal-task {
  margin-inline: auto;
  margin-top: 7rem;
  width: 90%;
  max-width: 28rem;
  min-height: 14.25rem;
  border-radius: 0.75rem;
  position: relative;
  padding: 1rem;
  position: absolute;
  background-color: var(--clr-bg-primary);
  overflow: visible;

  &::backdrop {
    background-color: var(--clr-bg-overlay-2);
  }

  #btn-close-modal {
    position: absolute;
    width: 1.25rem;
    height: 1.25rem;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
  }

  .row-3,
  .row-4 {
    display: flex;
    justify-content: space-between;
    align-items: center;

    > div {
      display: flex;
      align-items: center;
      width: fit-content;
      gap: 0.5rem;
      cursor: pointer;

      > * {
        cursor: pointer;
      }

      > input {
        max-width: 5.5rem;
      }
    }

    .priority-picker {
      display: none;
      cursor: initial;

      > * {
        cursor: initial;
      }
    }
  }

  .row-3 {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
    position: relative;
    padding-bottom: 1.25rem;
    border-bottom: 1px solid var(--clr-divider);
    margin-top: 1.5rem;
  }

  .row-4 {
    margin-top: 1rem;

    .actions {
      display: flex;
      align-items: center;
      gap: 0.75rem;

      #btn-save-changes,
      #btn-delete {
        display: flex;
        align-items: center;
        border-radius: 0.5rem;
      }

      #btn-save-changes {
        padding: 0.625rem;
        gap: 0.25rem;
        border: 1px solid var(--clr-text-tertiary);

        > span {
          color: var(--clr-text-secondary);
          font-size: 1rem;
        }
      }

      #btn-delete {
        padding: 0.625rem;
        border: 1px solid var(--clr-red-400);
        background-color: hsla(0, 68%, 60%, 0.06);
      }
    }
  }
}

.btn {
  padding-block: 0.75rem;
  color: var(--clr-text-primary);
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0.75rem;
}

.btn-primary {
  background-color: var(--clr-bg-btn-primary);

  &[type='submit'] {
    padding: 0.75rem 2.5rem;
  }
}

.btn-secondary {
  background: transparent;
  border: 1px solid var(--clr-accent-brand);
}

.btn-add {
  padding-block: 0.85rem;
  margin-block: 2.5rem;
  width: 100%;
  background-color: var(--clr-bg-secondary);
  color: var(--clr-text-light-blue);
  font-size: 1rem;
  gap: 0.5rem;

  &.hidden {
    display: none;
  }

  &::before {
    content: '';
    display: inline-block;
    width: 1rem;
    height: 1rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
    background-repeat: no-repeat;
  }
}

.btn-sidebar {
  margin-left: 0.5rem;
  margin-top: 1rem;
  width: 2.75rem;
  height: 2.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

#modal-start {
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 86%;

  .logo {
    width: 3.313rem;
    height: auto;
    margin-bottom: 1rem;
  }

  h1 {
    margin-bottom: 1rem;
  }

  > p {
    margin-bottom: 1.25rem;
  }

  button {
    width: 100%;
  }

  .pagination {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-top: 1.25rem;

    > div {
      border-radius: 9999px;
      width: 0.5rem;
      height: 0.5rem;
      background: #fff;
      cursor: pointer;

      &.active {
        width: 0.625rem;
        height: 0.625rem;
        background: var(--clr-accent-brand);
      }
    }
  }

  .actions {
    width: 100%;
    display: flex;
    gap: 0.5rem;

    button {
      flex: 1;
    }
  }

  form {
    width: 100%;
  }

  input {
    width: 100%;
    padding: 1rem;
    border-radius: 0.5rem;
    border: none;
    background-color: var(--clr-dark-blue-700);
    color: var(--clr-text-primary);
    margin-bottom: 1.25rem;

    &::placeholder {
      color: var(--clr-text-tertiary);
    }
  }
}

.task-list-item {
  padding-block: 0.75rem;
  color: var(--clr-text-primary);
  border-bottom: 0.5px solid var(--clr-divider);

  .input-wrapper {
    display: flex;
    gap: 0.75rem;
    align-items: center;
    cursor: pointer;

    label {
      cursor: pointer;
      transition: all 0.2s ease;
    }

    input[type='checkbox'] {
      appearance: none;
      -webkit-appearance: none;
      height: 1rem;
      width: 1rem;
      border-radius: 4px;
      border: 1.5px solid var(--clr-text-primary);
      background-color: transparent;
      cursor: pointer;
      position: relative;
      flex-shrink: 0;

      &:checked {
        border-color: var(--clr-text-secondary);

        &::after {
          content: '✓';
          position: absolute;
          color: var(--clr-text-secondary);
          font-size: 0.75rem;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      &.low {
        border-color: var(--clr-text-light-blue);
        &:checked {
          border-color: var(--clr-text-secondary);
        }
      }

      &.medium {
        border-color: var(--clr-yellow-400);
        &:checked {
          border-color: var(--clr-text-secondary);
        }
      }

      &.high {
        border-color: var(--clr-red-400);
        &:checked {
          border-color: var(--clr-text-secondary);
        }
      }
    }

    input[type='checkbox']:checked ~ label {
      text-decoration: line-through;
      opacity: 0.6;
      color: var(--clr-text-secondary);
    }
  }

  .row-top,
  .row-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .row-bottom {
    margin-top: 0.25rem;
    padding-left: 1.75rem;

    > * {
      color: var(--clr-text-secondary);
      font-size: 0.75rem;
    }
  }

  .due {
    min-width: 3rem;
    &.past-due {
      color: var(--clr-red-400);
    }
  }

  .priority {
    min-width: 0.75rem;
    font-size: 0.75rem;
    &.low {
      color: var(--clr-text-light-blue);
    }
    &.medium {
      color: var(--clr-yellow-400);
    }
    &.high {
      color: var(--clr-red-400);
    }
  }

  .custom-list {
    min-width: 2rem;
  }
}

.form-task {
  input,
  textarea {
    width: 90%;
    background: transparent;
    border: none;
    color: var(--clr-text-primary);
    caret-color: var(--clr-text-light-blue);

    &:focus-visible {
      outline: none;
    }

    &::placeholder {
      color: var(--clr-text-tertiary);
    }
  }

  textarea {
    resize: none;
    field-sizing: content;
  }

  #task-title {
    margin-bottom: 1rem;
  }

  #task-title,
  #task-title::placeholder {
    font-size: 1.25rem;
    font-weight: 600;
  }
}

/* Calendar */
.air-datepicker.custom-calendar-theme {
  width: fit-content;
  background: var(--clr-dark-blue-500);
  color: var(--clr-text-primary);
  font-size: 1rem;
  font-family: 'Roobert PRO', sans-serif;
  border-radius: 0.5rem;
  border: 1px solid var(--clr-divider);

  .air-datepicker--pointer {
    display: none;
  }

  .air-datepicker-nav {
    border-bottom: none;
  }

  .air-datepicker-nav {
    padding-top: 1rem;
  }

  .air-datepicker-nav--title {
    > * {
      color: var(--clr-text-primary);
      font-size: 1rem;
    }

    &:hover {
      background: var(--clr-bg-primary);
    }
  }

  .air-datepicker-nav--action {
    svg path {
      stroke: var(--clr-text-light-blue);
    }

    &:hover {
      background: var(--clr-bg-primary);
    }
  }

  .air-datepicker--content {
    padding: 0.5rem 0.75rem;
  }

  .air-datepicker-body--day-names {
    margin: 0;
    padding: 0;
  }

  .air-datepicker-body--day-name {
    color: var(--clr-text-secondary);
    font-size: 0.875rem;
    text-transform: none;
    width: 2.5rem;
    height: 2.5rem;
  }

  .air-datepicker-body--cells.-days- {
    grid-template-columns: repeat(7, 2.5rem);
    grid-auto-rows: 2.5rem;
  }

  .air-datepicker-cell {
    font-size: 0.875rem;

    &:hover {
      background: var(--clr-bg-secondary);
    }
  }

  .air-datepicker-cell.-day-.-other-month-,
  .air-datepicker-cell.-day-.-disabled- {
    color: var(--clr-text-tertiary);
  }

  .air-datepicker-cell.-selected- {
    background-color: var(--clr-text-light-blue);
    color: var(--clr-bg-primary);
    font-weight: 600;
  }

  .air-datepicker-cell.-current- {
    color: var(--clr-text-light-blue);

    &.-selected- {
      color: var(--clr-bg-primary);
      font-weight: 600;
    }
  }
}
/* Calendar end */

/* Pickers start */
.priority-picker,
.list-picker {
  display: none;
  opacity: 0;
  position: absolute;
  background-color: var(--clr-dark-blue-500);
  padding: 0.75rem 1rem;
  border: 1px solid var(--clr-divider);
  border-radius: 0.5rem;
  transition: opacity 0.2s ease-in-out;
  z-index: 10;

  &.visible {
    display: block !important;
    opacity: 1;
  }

  h5 {
    font-size: 1rem;
    font-weight: 500;
    margin: 0;
    margin-bottom: 0.625rem;
  }

  > ul {
    display: grid;
    gap: 0.25rem;
  }

  li {
    padding: 0.5rem;
    display: flex;
    gap: 0.25rem;
    cursor: pointer;

    .text {
      color: var(--clr-text-secondary);
      font-size: 0.9rem;
    }

    &.active {
      background-color: var(--clr-bg-secondary);
      border-radius: 0.25rem;
      .text {
        color: var(--clr-text-light-blue);
        font-weight: 500;
      }
    }
  }
}

.priority-picker {
  left: 0;
  top: 86%;

  li {
    .exclamation {
      font-size: 0.875rem;
      width: 1rem;
      height: 1rem;
      text-align: center;
      display: flex;
      &.low {
        color: var(--clr-text-light-blue);
      }
      &.medium {
        color: var(--clr-yellow-400);
      }
      &.high {
        color: var(--clr-red-400);
      }
    }
  }
}

.list-picker {
  display: none !important;
  left: 1rem;
  bottom: -10.25rem;

  li {
    align-items: center;
    gap: 0.5rem;
  }
}
/* Pickers end */

/* Desktops */
@media (min-width: 992px) {
  body {
    padding: 0.75rem;
    overflow-x: hidden;
  }

  body:has(.sidebar.visible) {
    pointer-events: auto;
  }

  #content {
    min-height: 97svh;
    display: grid;
    grid-template-columns: 22rem 1fr;
    gap: 6.5rem;
  }

  .btn-add {
    transition: background-color 0.3s ease;
    &::before {
      content: '';
      display: inline-block;
      width: 1.25rem;
      height: 1.25rem;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
      background-repeat: no-repeat;
    }

    &:hover {
      background-color: hsla(217, 48%, 20%, 1);
    }
  }

  .btn-sidebar {
    display: none;
    pointer-events: none;
  }

  .sidebar {
    position: revert;
    transform: initial;
    min-width: 21.75rem;
    padding: 2rem;
    border-radius: 1.5rem;
    border: 1px solid var(--clr-divider, #1c2533);

    .greeting img {
      width: 2.5rem;
      height: 2.5rem;
    }
  }

  .main {
    max-width: 34rem;
    margin-top: 4rem;
    padding: 0;
  }

  dialog {
    padding: 2rem;
  }

  dialog#modal-add-task {
    padding: 1.25rem;
  }

  #modal-start {
    width: fit-content;
    .logo {
      width: 4.125rem;
    }

    h1 {
      min-width: 20rem;
    }

    > p {
      max-width: 20rem;
      margin-bottom: 2rem;
    }

    button {
      padding-block: 1rem;
    }

    .pagination {
      margin-top: 2rem;
    }

    input {
      margin-bottom: 2rem;
    }
  }

  dialog#modal-task {
    margin-top: 11.125rem;
    width: 36.5rem;
    max-width: initial;
    min-height: initial;

    .row-3 {
      display: flex;
      justify-content: space-between;
    }
  }

  .priority-picker,
  .list-picker {
    li {
      transition: background-color 0.2s ease;
      &:hover {
        background-color: var(--clr-bg-secondary);
        border-radius: 0.25rem;

        .text {
          color: var(--clr-text-primary);
        }
      }
    }
  }

  .priority-picker {
    left: initial;
    right: 0;
    top: 70%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,2CAA2C;EAC3C,2CAA2C;EAC3C,2CAA2C;EAC3C,0CAA0C;EAC1C,4CAA4C;EAC5C,uCAAuC;EACvC,mCAAmC;EACnC,0CAA0C;;EAE1C,eAAe;EACf,0CAA0C;EAC1C,4CAA4C;EAC5C,0CAA0C;EAC1C,wCAAwC;EACxC,wCAAwC;EACxC,6CAA6C;;EAE7C,SAAS;EACT,wCAAwC;EACxC,yCAAyC;EACzC,wCAAwC;EACxC,gDAAgD;;EAEhD,YAAY;EACZ,qCAAqC;;EAErC,uBAAuB;EACvB,wCAAwC;EACxC,uCAAuC;EACvC,uCAAuC;EACvC,yCAAyC;EACzC,wCAAwC;EACxC,uCAAuC;;EAEvC,eAAe;EACf,sDAAsD;EACtD,sDAAsD;AACxD;;AAEA,eAAe;AACf;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,kBAAkB;AACpB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;;;;;;;;;EAUE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;;;;;;;EAOE,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;;;;;;;EAOE,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;;;;EAIE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,gCAAgC;EAClC;AACF;AACA,mBAAmB;;AAEnB,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,4DAAmE;EACnE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,4DAAkE;EAClE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,4DAAgE;EAChE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,sCAAsC;EACtC,uCAAuC;EACvC,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;;EAIE,SAAS;EACT,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,yDAAyD;EACzD,gBAAgB;AAClB;;AAEA;EACE,sDAAsD;EACtD,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,QAAQ;EACR,OAAO;EACP,YAAY;EACZ,6BAA6B;EAC7B,6DAA6D;;EAE7D,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uCAAuC;EACvC,4BAA4B;EAC5B,iDAAiD;EACjD,mDAAmD;EACnD,oDAAoD;;EAEpD;IACE,wBAAwB;EAC1B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;;IAEZ;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA;IACE,aAAa;IACb,sBAAsB;;IAEtB;MACE,gBAAgB;MAChB,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,YAAY;MACZ,gCAAgC;MAChC,uBAAuB;;MAEvB;QACE,aAAa;QACb,mBAAmB;QACnB,YAAY;;QAEZ;UACE,+BAA+B;QACjC;;QAEA;UACE,eAAe;QACjB;MACF;;MAEA;QACE,mBAAmB;MACrB;;MAEA;QACE,yCAAyC;QACzC,iCAAiC;;QAEjC;UACE,gBAAgB;QAClB;;QAEA;UACE,gCAAgC;QAClC;MACF;IACF;EACF;;EAEA;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,6BAA6B;IAC/B;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,4BAA4B;IAC9B;;IAEA;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;MACZ,kBAAkB;MAClB,sBAAsB;MACtB,WAAW;MACX,UAAU;MACV,6BAA6B;;MAE7B;QACE,8BAA8B;QAC9B,2BAA2B;MAC7B;;MAEA;QACE,gCAAgC;MAClC;;MAEA;QACE,UAAU;QACV;6BACqB;QACrB,aAAa;MACf;IACF;;IAEA;MACE,kBAAkB;MAClB,sBAAsB;MACtB,aAAa;MACb,gBAAgB;MAChB,8BAA8B;MAC9B,YAAY;;MAEZ;QACE,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,WAAW;;QAEX;UACE,mBAAmB;UACnB,gCAAgC;QAClC;;QAEA;UACE,uBAAuB;UACvB,eAAe;UACf,WAAW;UACX,yCAAyC;UACzC,8BAA8B;UAC9B,YAAY;QACd;MACF;;MAEA;QACE,uBAAuB;QACvB,uBAAuB;QACvB,yCAAyC;QACzC,8BAA8B;MAChC;IACF;EACF;AACF;;AAEA;;;;EAIE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,oCAAoC;EACpC,qBAAqB;;EAErB;IACE,8BAA8B;EAChC;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,iBAAiB;;EAEjB;IACE,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,SAAS;IACT,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;IAEnB;MACE,aAAa;MACb,mBAAmB;MACnB,kBAAkB;MAClB,WAAW;MACX,eAAe;;MAEf;QACE,eAAe;MACjB;;MAEA;QACE,iBAAiB;MACnB;IACF;;IAEA;MACE,aAAa;MACb,eAAe;;MAEf;QACE,eAAe;MACjB;IACF;EACF;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;;IAEhB;MACE,aAAa;MACb,mBAAmB;MACnB,YAAY;;MAEZ;;QAEE,aAAa;QACb,mBAAmB;QACnB,qBAAqB;MACvB;;MAEA;QACE,iBAAiB;QACjB,YAAY;QACZ,0CAA0C;;QAE1C;UACE,gCAAgC;UAChC,eAAe;QACjB;MACF;;MAEA;QACE,iBAAiB;QACjB,oCAAoC;QACpC,yCAAyC;MAC3C;IACF;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,2CAA2C;;EAE3C;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,yCAAyC;EACzC,iCAAiC;EACjC,eAAe;EACf,WAAW;;EAEX;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,yDAA60B;IAC70B,4BAA4B;EAC9B;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;;EAEV;IACE,eAAe;IACf,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;;IAEnB;MACE,qBAAqB;MACrB,aAAa;MACb,cAAc;MACd,gBAAgB;MAChB,eAAe;;MAEf;QACE,eAAe;QACf,gBAAgB;QAChB,mCAAmC;MACrC;IACF;EACF;;EAEA;IACE,WAAW;IACX,aAAa;IACb,WAAW;;IAEX;MACE,OAAO;IACT;EACF;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,aAAa;IACb,qBAAqB;IACrB,YAAY;IACZ,0CAA0C;IAC1C,8BAA8B;IAC9B,sBAAsB;;IAEtB;MACE,+BAA+B;IACjC;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,8BAA8B;EAC9B,6CAA6C;;EAE7C;IACE,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,eAAe;;IAEf;MACE,eAAe;MACf,yBAAyB;IAC3B;;IAEA;MACE,gBAAgB;MAChB,wBAAwB;MACxB,YAAY;MACZ,WAAW;MACX,kBAAkB;MAClB,2CAA2C;MAC3C,6BAA6B;MAC7B,eAAe;MACf,kBAAkB;MAClB,cAAc;;MAEd;QACE,uCAAuC;;QAEvC;UACE,YAAY;UACZ,kBAAkB;UAClB,gCAAgC;UAChC,kBAAkB;UAClB,QAAQ;UACR,SAAS;UACT,gCAAgC;QAClC;MACF;;MAEA;QACE,wCAAwC;QACxC;UACE,uCAAuC;QACzC;MACF;;MAEA;QACE,mCAAmC;QACnC;UACE,uCAAuC;QACzC;MACF;;MAEA;QACE,gCAAgC;QAChC;UACE,uCAAuC;QACzC;MACF;IACF;;IAEA;MACE,6BAA6B;MAC7B,YAAY;MACZ,gCAAgC;IAClC;EACF;;EAEA;;IAEE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;;IAErB;MACE,gCAAgC;MAChC,kBAAkB;IACpB;EACF;;EAEA;IACE,eAAe;IACf;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB;MACE,iCAAiC;IACnC;IACA;MACE,4BAA4B;IAC9B;IACA;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;IAEE,UAAU;IACV,uBAAuB;IACvB,YAAY;IACZ,8BAA8B;IAC9B,uCAAuC;;IAEvC;MACE,aAAa;IACf;;IAEA;MACE,+BAA+B;IACjC;EACF;;EAEA;IACE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,oCAAoC;EACpC,8BAA8B;EAC9B,eAAe;EACf,sCAAsC;EACtC,qBAAqB;EACrB,oCAAoC;;EAEpC;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE;MACE,8BAA8B;MAC9B,eAAe;IACjB;;IAEA;MACE,iCAAiC;IACnC;EACF;;EAEA;IACE;MACE,kCAAkC;IACpC;;IAEA;MACE,iCAAiC;IACnC;EACF;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,wCAAwC;IACxC,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;;IAEnB;MACE,mCAAmC;IACrC;EACF;;EAEA;;IAEE,+BAA+B;EACjC;;EAEA;IACE,4CAA4C;IAC5C,4BAA4B;IAC5B,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;;IAEjC;MACE,4BAA4B;MAC5B,gBAAgB;IAClB;EACF;AACF;AACA,iBAAiB;;AAEjB,kBAAkB;AAClB;;EAEE,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,0CAA0C;EAC1C,qBAAqB;EACrB,oCAAoC;EACpC,qBAAqB;EACrB,oCAAoC;EACpC,WAAW;;EAEX;IACE,yBAAyB;IACzB,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,eAAe;IACf,aAAa;IACb,YAAY;IACZ,eAAe;;IAEf;MACE,gCAAgC;MAChC,iBAAiB;IACnB;;IAEA;MACE,yCAAyC;MACzC,sBAAsB;MACtB;QACE,iCAAiC;QACjC,gBAAgB;MAClB;IACF;EACF;AACF;;AAEA;EACE,OAAO;EACP,QAAQ;;EAER;IACE;MACE,mBAAmB;MACnB,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,aAAa;MACb;QACE,iCAAiC;MACnC;MACA;QACE,4BAA4B;MAC9B;MACA;QACE,yBAAyB;MAC3B;IACF;EACF;AACF;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,iBAAiB;;EAEjB;IACE,mBAAmB;IACnB,WAAW;EACb;AACF;AACA,gBAAgB;;AAEhB,aAAa;AACb;EACE;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,sCAAsC;IACtC;MACE,WAAW;MACX,qBAAqB;MACrB,cAAc;MACd,eAAe;MACf,yDAA05B;MAC15B,4BAA4B;IAC9B;;IAEA;MACE,wCAAwC;IAC1C;EACF;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,qBAAqB;IACrB,6CAA6C;;IAE7C;MACE,aAAa;MACb,cAAc;IAChB;EACF;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB;MACE,eAAe;IACjB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,gBAAgB;IAClB;;IAEA;MACE,mBAAmB;IACrB;EACF;;EAEA;IACE,qBAAqB;IACrB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;;IAEnB;MACE,aAAa;MACb,8BAA8B;IAChC;EACF;;EAEA;;IAEE;MACE,sCAAsC;MACtC;QACE,yCAAyC;QACzC,sBAAsB;;QAEtB;UACE,8BAA8B;QAChC;MACF;IACF;EACF;;EAEA;IACE,aAAa;IACb,QAAQ;IACR,QAAQ;EACV;AACF","sourcesContent":[":root {\n  /* Primitives */\n  --clr-dark-blue-300: hsla(218, 48%, 17%, 1);\n  --clr-dark-blue-400: hsla(218, 47%, 13%, 1);\n  --clr-dark-blue-500: hsla(218, 48%, 10%, 1);\n  --clr-dark-blue-700: hsla(215, 50%, 5%, 1);\n  --clr-light-blue-400: hsla(223, 87%, 76%, 1);\n  --clr-yellow-400: hsla(58, 99%, 72%, 1);\n  --clr-red-400: hsla(0, 68%, 60%, 1);\n  --clr-accent-brand: hsla(241, 61%, 55%, 1);\n\n  /* Background */\n  --clr-bg-primary: var(--clr-dark-blue-400);\n  --clr-bg-secondary: var(--clr-dark-blue-300);\n  --clr-bg-overlay: var(--clr-dark-blue-700);\n  --clr-bg-overlay-2: hsla(0, 0%, 0%, 0.5);\n  --clr-bg-sidebar: hsla(218, 48%, 10%, 1);\n  --clr-bg-btn-primary: var(--clr-accent-brand);\n\n  /* Text */\n  --clr-text-primary: hsla(0, 0%, 100%, 1);\n  --clr-text-secondary: hsla(0, 0%, 65%, 1);\n  --clr-text-tertiary: hsla(0, 0%, 41%, 1);\n  --clr-text-light-blue: var(--clr-light-blue-400);\n\n  /* Divider */\n  --clr-divider: hsla(217, 29%, 15%, 1);\n\n  /* List marker colors */\n  --clr-list-green: hsla(115, 63%, 77%, 1);\n  --clr-list-blue: hsla(209, 86%, 71%, 1);\n  --clr-list-pink: hsla(320, 94%, 73%, 1);\n  --clr-list-purple: hsla(265, 38%, 58%, 1);\n  --clr-list-orange: hsla(25, 89%, 60%, 1);\n  --clr-list-mint: hsla(173, 96%, 82%, 1);\n\n  /* Font sizes */\n  --fs-h1: clamp(1.5rem, 1.3269rem + 0.7692vw, 1.875rem);\n  --fs-body: clamp(0.875rem, 0.8173rem + 0.2564vw, 1rem);\n}\n\n/* Mini reset */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  overflow-x: hidden;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  -moz-text-size-adjust: none;\n  -webkit-text-size-adjust: none;\n  text-size-adjust: none;\n}\n\nbody,\nh1,\nh2,\nh3,\nh4,\np,\nfigure,\nblockquote,\ndl,\ndd {\n  margin-block-end: 0;\n}\n\nul {\n  list-style: none;\n}\n\nbody {\n  min-height: 100vh;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  font-size-adjust: 0.52;\n}\n\nh1,\nh2,\nh3,\nh4,\nbutton,\ninput,\nlabel {\n  line-height: 1.1;\n}\n\nh1,\nh2,\nh3,\nh4 {\n  text-wrap: balance;\n}\n\np {\n  text-wrap: pretty;\n  margin: 0;\n}\n\np,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  overflow-wrap: break-word;\n}\n\nul {\n  padding: 0;\n  margin: 0;\n}\n\nimg,\npicture {\n  max-width: 100%;\n  display: block;\n}\n\nbutton {\n  border: none;\n  cursor: pointer;\n  background-color: transparent;\n  padding: 0;\n}\n\ninput,\nbutton,\ntextarea,\nselect {\n  font-family: inherit;\n  font-size: inherit;\n}\n\n:target {\n  scroll-margin-block: 5ex;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  html {\n    interpolate-size: allow-keywords;\n  }\n}\n/* Mini reset end */\n\n/* Custom fonts */\n@font-face {\n  font-family: 'Roobert PRO';\n  src: url('./assets/fonts/RoobertPRO-Regular.woff2') format('woff2');\n  font-weight: 400;\n  font-style: normal;\n  font-display: block;\n}\n\n@font-face {\n  font-family: 'Roobert PRO';\n  src: url('./assets/fonts/RoobertPRO-Medium.woff2') format('woff2');\n  font-weight: 500;\n  font-style: normal;\n  font-display: block;\n}\n\n@font-face {\n  font-family: 'Roobert PRO';\n  src: url('./assets/fonts/RoobertPRO-Bold.woff2') format('woff2');\n  font-weight: 700;\n  font-style: normal;\n  font-display: block;\n}\n\n/* Styles */\nbody {\n  font-family: 'Roobert PRO', sans-serif;\n  background-color: var(--clr-bg-primary);\n  text-rendering: optimizeSpeed;\n  line-height: 1.5;\n}\n\nbody:has(.sidebar.visible) {\n  pointer-events: none;\n}\n\n#content {\n  min-height: 100svh;\n}\n\n#content:has(dialog) {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\nh1 {\n  font-size: var(--fs-h1);\n}\n\np,\nbutton {\n  font-size: var(--fs-body);\n}\n\nh1,\nh2,\nh3,\nh4 {\n  margin: 0;\n  padding: 0;\n  color: var(--clr-text-primary);\n}\n\nh3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n}\n\n#list-title {\n  color: var(--clr-text-light-blue);\n  font-size: clamp(1.875rem, 1.4712rem + 1.7949vw, 2.75rem);\n  font-weight: 700;\n}\n\n#todays-date {\n  font-size: clamp(1rem, 0.9423rem + 0.2564vw, 1.125rem);\n  color: var(--clr-text-secondary);\n  margin-top: 0.5rem;\n}\n\n.sidebar {\n  width: 18.375rem;\n  height: 100%;\n  position: fixed;\n  top: 0px;\n  left: 0;\n  z-index: 100;\n  transform: translateX(-60rem);\n  transition: transform 0.3s cubic-bezier(0.165, 0.84, 0.44, 1);\n\n  padding: 2rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  background-color: var(--clr-bg-sidebar);\n  border-radius: 0 1rem 1rem 0;\n  border-top: 1px solid var(--clr-divider, #1c2533);\n  border-right: 1px solid var(--clr-divider, #1c2533);\n  border-bottom: 1px solid var(--clr-divider, #1c2533);\n\n  &.visible {\n    transform: translateX(0);\n  }\n\n  .greeting {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n\n    img {\n      width: 2rem;\n      height: 2rem;\n    }\n  }\n\n  ul {\n    display: flex;\n    flex-direction: column;\n\n    > li button {\n      padding: 0.75rem;\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      height: 3rem;\n      color: var(--clr-text-secondary);\n      border-radius: 0.625rem;\n\n      > div {\n        display: flex;\n        align-items: center;\n        gap: 0.75rem;\n\n        svg {\n          fill: var(--clr-text-secondary);\n        }\n\n        p {\n          font-size: 1rem;\n        }\n      }\n\n      span {\n        font-size: 0.875rem;\n      }\n\n      &.active {\n        background-color: var(--clr-bg-secondary);\n        color: var(--clr-text-light-blue);\n\n        p {\n          font-weight: 500;\n        }\n\n        svg {\n          fill: var(--clr-text-light-blue);\n        }\n      }\n    }\n  }\n\n  .custom-list {\n    h3 {\n      margin-bottom: 0.75rem;\n    }\n\n    svg {\n      fill: none;\n    }\n\n    button.active svg {\n      fill: none;\n    }\n\n    > ul li:first-child button > div svg {\n      stroke: var(--clr-list-green);\n    }\n\n    > ul li:nth-child(2) button > div svg {\n      stroke: var(--clr-list-blue);\n    }\n\n    > ul li:nth-child(3) button > div svg {\n      stroke: var(--clr-list-pink);\n    }\n\n    .btn-add-list {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n      margin-top: 0.5rem;\n      padding-block: 0.75rem;\n      width: 100%;\n      opacity: 1;\n      transition: all 0.4s ease-out;\n\n      span {\n        color: var(--clr-text-primary);\n        transition: color 0.4s ease;\n      }\n\n      &:hover span {\n        color: var(--clr-text-secondary);\n      }\n\n      &.hidden {\n        opacity: 0;\n        /* transform: translateY(-5rem);\n        position: absolute; */\n        display: none;\n      }\n    }\n\n    #form-custom-list {\n      margin-top: 0.5rem;\n      padding-block: 0.75rem;\n      display: flex;\n      align-items: end;\n      justify-content: space-between;\n      gap: 0.75rem;\n\n      > div {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n        gap: 0.5rem;\n\n        label {\n          font-size: 0.825rem;\n          color: var(--clr-text-secondary);\n        }\n\n        input {\n          border-radius: 0.325rem;\n          padding: 0.6rem;\n          width: 100%;\n          background-color: var(--clr-bg-secondary);\n          color: var(--clr-text-primary);\n          border: none;\n        }\n      }\n\n      button {\n        padding: 0.6rem 0.75rem;\n        border-radius: 0.325rem;\n        background-color: var(--clr-accent-brand);\n        color: var(--clr-text-primary);\n      }\n    }\n  }\n}\n\n.sidebar.visible,\n.sidebar.visible *,\n.sidebar.visible button,\n.sidebar.visible a {\n  pointer-events: auto !important;\n}\n\n.main {\n  margin-top: 1.5rem;\n  padding: 0 1rem;\n}\n\ndialog {\n  padding: 1.25rem;\n  background-color: var(--clr-bg-primary);\n  border: 1px solid var(--clr-divider);\n  border-radius: 1.5rem;\n\n  > * {\n    color: var(--clr-text-primary);\n  }\n\n  &::backdrop {\n    background-color: var(--clr-bg-overlay);\n  }\n}\n\ndialog#modal-task {\n  margin-inline: auto;\n  margin-top: 7rem;\n  width: 90%;\n  max-width: 28rem;\n  min-height: 14.25rem;\n  border-radius: 0.75rem;\n  position: relative;\n  padding: 1rem;\n  position: absolute;\n  background-color: var(--clr-bg-primary);\n  overflow: visible;\n\n  &::backdrop {\n    background-color: var(--clr-bg-overlay-2);\n  }\n\n  #btn-close-modal {\n    position: absolute;\n    width: 1.25rem;\n    height: 1.25rem;\n    top: 1rem;\n    right: 1rem;\n    cursor: pointer;\n  }\n\n  .row-3,\n  .row-4 {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n    > div {\n      display: flex;\n      align-items: center;\n      width: fit-content;\n      gap: 0.5rem;\n      cursor: pointer;\n\n      > * {\n        cursor: pointer;\n      }\n\n      > input {\n        max-width: 5.5rem;\n      }\n    }\n\n    .priority-picker {\n      display: none;\n      cursor: initial;\n\n      > * {\n        cursor: initial;\n      }\n    }\n  }\n\n  .row-3 {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 1.5rem;\n    position: relative;\n    padding-bottom: 1.25rem;\n    border-bottom: 1px solid var(--clr-divider);\n    margin-top: 1.5rem;\n  }\n\n  .row-4 {\n    margin-top: 1rem;\n\n    .actions {\n      display: flex;\n      align-items: center;\n      gap: 0.75rem;\n\n      #btn-save-changes,\n      #btn-delete {\n        display: flex;\n        align-items: center;\n        border-radius: 0.5rem;\n      }\n\n      #btn-save-changes {\n        padding: 0.625rem;\n        gap: 0.25rem;\n        border: 1px solid var(--clr-text-tertiary);\n\n        > span {\n          color: var(--clr-text-secondary);\n          font-size: 1rem;\n        }\n      }\n\n      #btn-delete {\n        padding: 0.625rem;\n        border: 1px solid var(--clr-red-400);\n        background-color: hsla(0, 68%, 60%, 0.06);\n      }\n    }\n  }\n}\n\n.btn {\n  padding-block: 0.75rem;\n  color: var(--clr-text-primary);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 0.75rem;\n}\n\n.btn-primary {\n  background-color: var(--clr-bg-btn-primary);\n\n  &[type='submit'] {\n    padding: 0.75rem 2.5rem;\n  }\n}\n\n.btn-secondary {\n  background: transparent;\n  border: 1px solid var(--clr-accent-brand);\n}\n\n.btn-add {\n  padding-block: 0.85rem;\n  margin-block: 2.5rem;\n  width: 100%;\n  background-color: var(--clr-bg-secondary);\n  color: var(--clr-text-light-blue);\n  font-size: 1rem;\n  gap: 0.5rem;\n\n  &.hidden {\n    display: none;\n  }\n\n  &::before {\n    content: '';\n    display: inline-block;\n    width: 1rem;\n    height: 1rem;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M14 8C14 8.13261 13.9473 8.25979 13.8536 8.35355C13.7598 8.44732 13.6326 8.5 13.5 8.5H8.5V13.5C8.5 13.6326 8.44732 13.7598 8.35355 13.8536C8.25979 13.9473 8.13261 14 8 14C7.86739 14 7.74021 13.9473 7.64645 13.8536C7.55268 13.7598 7.5 13.6326 7.5 13.5V8.5H2.5C2.36739 8.5 2.24021 8.44732 2.14645 8.35355C2.05268 8.25979 2 8.13261 2 8C2 7.86739 2.05268 7.74021 2.14645 7.64645C2.24021 7.55268 2.36739 7.5 2.5 7.5H7.5V2.5C7.5 2.36739 7.55268 2.24021 7.64645 2.14645C7.74021 2.05268 7.86739 2 8 2C8.13261 2 8.25979 2.05268 8.35355 2.14645C8.44732 2.24021 8.5 2.36739 8.5 2.5V7.5H13.5C13.6326 7.5 13.7598 7.55268 13.8536 7.64645C13.9473 7.74021 14 7.86739 14 8Z' fill='%238DABF7'/%3E%3C/svg%3E%0A\");\n    background-repeat: no-repeat;\n  }\n}\n\n.btn-sidebar {\n  margin-left: 0.5rem;\n  margin-top: 1rem;\n  width: 2.75rem;\n  height: 2.75rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n#modal-start {\n  margin: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  width: 86%;\n\n  .logo {\n    width: 3.313rem;\n    height: auto;\n    margin-bottom: 1rem;\n  }\n\n  h1 {\n    margin-bottom: 1rem;\n  }\n\n  > p {\n    margin-bottom: 1.25rem;\n  }\n\n  button {\n    width: 100%;\n  }\n\n  .pagination {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    margin-top: 1.25rem;\n\n    > div {\n      border-radius: 9999px;\n      width: 0.5rem;\n      height: 0.5rem;\n      background: #fff;\n      cursor: pointer;\n\n      &.active {\n        width: 0.625rem;\n        height: 0.625rem;\n        background: var(--clr-accent-brand);\n      }\n    }\n  }\n\n  .actions {\n    width: 100%;\n    display: flex;\n    gap: 0.5rem;\n\n    button {\n      flex: 1;\n    }\n  }\n\n  form {\n    width: 100%;\n  }\n\n  input {\n    width: 100%;\n    padding: 1rem;\n    border-radius: 0.5rem;\n    border: none;\n    background-color: var(--clr-dark-blue-700);\n    color: var(--clr-text-primary);\n    margin-bottom: 1.25rem;\n\n    &::placeholder {\n      color: var(--clr-text-tertiary);\n    }\n  }\n}\n\n.task-list-item {\n  padding-block: 0.75rem;\n  color: var(--clr-text-primary);\n  border-bottom: 0.5px solid var(--clr-divider);\n\n  .input-wrapper {\n    display: flex;\n    gap: 0.75rem;\n    align-items: center;\n    cursor: pointer;\n\n    label {\n      cursor: pointer;\n      transition: all 0.2s ease;\n    }\n\n    input[type='checkbox'] {\n      appearance: none;\n      -webkit-appearance: none;\n      height: 1rem;\n      width: 1rem;\n      border-radius: 4px;\n      border: 1.5px solid var(--clr-text-primary);\n      background-color: transparent;\n      cursor: pointer;\n      position: relative;\n      flex-shrink: 0;\n\n      &:checked {\n        border-color: var(--clr-text-secondary);\n\n        &::after {\n          content: '✓';\n          position: absolute;\n          color: var(--clr-text-secondary);\n          font-size: 0.75rem;\n          top: 50%;\n          left: 50%;\n          transform: translate(-50%, -50%);\n        }\n      }\n\n      &.low {\n        border-color: var(--clr-text-light-blue);\n        &:checked {\n          border-color: var(--clr-text-secondary);\n        }\n      }\n\n      &.medium {\n        border-color: var(--clr-yellow-400);\n        &:checked {\n          border-color: var(--clr-text-secondary);\n        }\n      }\n\n      &.high {\n        border-color: var(--clr-red-400);\n        &:checked {\n          border-color: var(--clr-text-secondary);\n        }\n      }\n    }\n\n    input[type='checkbox']:checked ~ label {\n      text-decoration: line-through;\n      opacity: 0.6;\n      color: var(--clr-text-secondary);\n    }\n  }\n\n  .row-top,\n  .row-bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n\n  .row-bottom {\n    margin-top: 0.25rem;\n    padding-left: 1.75rem;\n\n    > * {\n      color: var(--clr-text-secondary);\n      font-size: 0.75rem;\n    }\n  }\n\n  .due {\n    min-width: 3rem;\n    &.past-due {\n      color: var(--clr-red-400);\n    }\n  }\n\n  .priority {\n    min-width: 0.75rem;\n    font-size: 0.75rem;\n    &.low {\n      color: var(--clr-text-light-blue);\n    }\n    &.medium {\n      color: var(--clr-yellow-400);\n    }\n    &.high {\n      color: var(--clr-red-400);\n    }\n  }\n\n  .custom-list {\n    min-width: 2rem;\n  }\n}\n\n.form-task {\n  input,\n  textarea {\n    width: 90%;\n    background: transparent;\n    border: none;\n    color: var(--clr-text-primary);\n    caret-color: var(--clr-text-light-blue);\n\n    &:focus-visible {\n      outline: none;\n    }\n\n    &::placeholder {\n      color: var(--clr-text-tertiary);\n    }\n  }\n\n  textarea {\n    resize: none;\n    field-sizing: content;\n  }\n\n  #task-title {\n    margin-bottom: 1rem;\n  }\n\n  #task-title,\n  #task-title::placeholder {\n    font-size: 1.25rem;\n    font-weight: 600;\n  }\n}\n\n/* Calendar */\n.air-datepicker.custom-calendar-theme {\n  width: fit-content;\n  background: var(--clr-dark-blue-500);\n  color: var(--clr-text-primary);\n  font-size: 1rem;\n  font-family: 'Roobert PRO', sans-serif;\n  border-radius: 0.5rem;\n  border: 1px solid var(--clr-divider);\n\n  .air-datepicker--pointer {\n    display: none;\n  }\n\n  .air-datepicker-nav {\n    border-bottom: none;\n  }\n\n  .air-datepicker-nav {\n    padding-top: 1rem;\n  }\n\n  .air-datepicker-nav--title {\n    > * {\n      color: var(--clr-text-primary);\n      font-size: 1rem;\n    }\n\n    &:hover {\n      background: var(--clr-bg-primary);\n    }\n  }\n\n  .air-datepicker-nav--action {\n    svg path {\n      stroke: var(--clr-text-light-blue);\n    }\n\n    &:hover {\n      background: var(--clr-bg-primary);\n    }\n  }\n\n  .air-datepicker--content {\n    padding: 0.5rem 0.75rem;\n  }\n\n  .air-datepicker-body--day-names {\n    margin: 0;\n    padding: 0;\n  }\n\n  .air-datepicker-body--day-name {\n    color: var(--clr-text-secondary);\n    font-size: 0.875rem;\n    text-transform: none;\n    width: 2.5rem;\n    height: 2.5rem;\n  }\n\n  .air-datepicker-body--cells.-days- {\n    grid-template-columns: repeat(7, 2.5rem);\n    grid-auto-rows: 2.5rem;\n  }\n\n  .air-datepicker-cell {\n    font-size: 0.875rem;\n\n    &:hover {\n      background: var(--clr-bg-secondary);\n    }\n  }\n\n  .air-datepicker-cell.-day-.-other-month-,\n  .air-datepicker-cell.-day-.-disabled- {\n    color: var(--clr-text-tertiary);\n  }\n\n  .air-datepicker-cell.-selected- {\n    background-color: var(--clr-text-light-blue);\n    color: var(--clr-bg-primary);\n    font-weight: 600;\n  }\n\n  .air-datepicker-cell.-current- {\n    color: var(--clr-text-light-blue);\n\n    &.-selected- {\n      color: var(--clr-bg-primary);\n      font-weight: 600;\n    }\n  }\n}\n/* Calendar end */\n\n/* Pickers start */\n.priority-picker,\n.list-picker {\n  display: none;\n  opacity: 0;\n  position: absolute;\n  background-color: var(--clr-dark-blue-500);\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--clr-divider);\n  border-radius: 0.5rem;\n  transition: opacity 0.2s ease-in-out;\n  z-index: 10;\n\n  &.visible {\n    display: block !important;\n    opacity: 1;\n  }\n\n  h5 {\n    font-size: 1rem;\n    font-weight: 500;\n    margin: 0;\n    margin-bottom: 0.625rem;\n  }\n\n  > ul {\n    display: grid;\n    gap: 0.25rem;\n  }\n\n  li {\n    padding: 0.5rem;\n    display: flex;\n    gap: 0.25rem;\n    cursor: pointer;\n\n    .text {\n      color: var(--clr-text-secondary);\n      font-size: 0.9rem;\n    }\n\n    &.active {\n      background-color: var(--clr-bg-secondary);\n      border-radius: 0.25rem;\n      .text {\n        color: var(--clr-text-light-blue);\n        font-weight: 500;\n      }\n    }\n  }\n}\n\n.priority-picker {\n  left: 0;\n  top: 86%;\n\n  li {\n    .exclamation {\n      font-size: 0.875rem;\n      width: 1rem;\n      height: 1rem;\n      text-align: center;\n      display: flex;\n      &.low {\n        color: var(--clr-text-light-blue);\n      }\n      &.medium {\n        color: var(--clr-yellow-400);\n      }\n      &.high {\n        color: var(--clr-red-400);\n      }\n    }\n  }\n}\n\n.list-picker {\n  display: none !important;\n  left: 1rem;\n  bottom: -10.25rem;\n\n  li {\n    align-items: center;\n    gap: 0.5rem;\n  }\n}\n/* Pickers end */\n\n/* Desktops */\n@media (min-width: 992px) {\n  body {\n    padding: 0.75rem;\n    overflow-x: hidden;\n  }\n\n  body:has(.sidebar.visible) {\n    pointer-events: auto;\n  }\n\n  #content {\n    min-height: 97svh;\n    display: grid;\n    grid-template-columns: 22rem 1fr;\n    gap: 6.5rem;\n  }\n\n  .btn-add {\n    transition: background-color 0.3s ease;\n    &::before {\n      content: '';\n      display: inline-block;\n      width: 1.25rem;\n      height: 1.25rem;\n      background-image: url(\"data:image/svg+xml,%3Csvg width='21' height='20' viewBox='0 0 21 20' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18 10C18 10.1658 17.9342 10.3247 17.8169 10.4419C17.6997 10.5592 17.5408 10.625 17.375 10.625H11.125V16.875C11.125 17.0408 11.0592 17.1997 10.9419 17.3169C10.8247 17.4342 10.6658 17.5 10.5 17.5C10.3342 17.5 10.1753 17.4342 10.0581 17.3169C9.94085 17.1997 9.875 17.0408 9.875 16.875V10.625H3.625C3.45924 10.625 3.30027 10.5592 3.18306 10.4419C3.06585 10.3247 3 10.1658 3 10C3 9.83424 3.06585 9.67527 3.18306 9.55806C3.30027 9.44085 3.45924 9.375 3.625 9.375H9.875V3.125C9.875 2.95924 9.94085 2.80027 10.0581 2.68306C10.1753 2.56585 10.3342 2.5 10.5 2.5C10.6658 2.5 10.8247 2.56585 10.9419 2.68306C11.0592 2.80027 11.125 2.95924 11.125 3.125V9.375H17.375C17.5408 9.375 17.6997 9.44085 17.8169 9.55806C17.9342 9.67527 18 9.83424 18 10Z' fill='%238DABF7'/%3E%3C/svg%3E%0A\");\n      background-repeat: no-repeat;\n    }\n\n    &:hover {\n      background-color: hsla(217, 48%, 20%, 1);\n    }\n  }\n\n  .btn-sidebar {\n    display: none;\n    pointer-events: none;\n  }\n\n  .sidebar {\n    position: revert;\n    transform: initial;\n    min-width: 21.75rem;\n    padding: 2rem;\n    border-radius: 1.5rem;\n    border: 1px solid var(--clr-divider, #1c2533);\n\n    .greeting img {\n      width: 2.5rem;\n      height: 2.5rem;\n    }\n  }\n\n  .main {\n    max-width: 34rem;\n    margin-top: 4rem;\n    padding: 0;\n  }\n\n  dialog {\n    padding: 2rem;\n  }\n\n  dialog#modal-add-task {\n    padding: 1.25rem;\n  }\n\n  #modal-start {\n    width: fit-content;\n    .logo {\n      width: 4.125rem;\n    }\n\n    h1 {\n      min-width: 20rem;\n    }\n\n    > p {\n      max-width: 20rem;\n      margin-bottom: 2rem;\n    }\n\n    button {\n      padding-block: 1rem;\n    }\n\n    .pagination {\n      margin-top: 2rem;\n    }\n\n    input {\n      margin-bottom: 2rem;\n    }\n  }\n\n  dialog#modal-task {\n    margin-top: 11.125rem;\n    width: 36.5rem;\n    max-width: initial;\n    min-height: initial;\n\n    .row-3 {\n      display: flex;\n      justify-content: space-between;\n    }\n  }\n\n  .priority-picker,\n  .list-picker {\n    li {\n      transition: background-color 0.2s ease;\n      &:hover {\n        background-color: var(--clr-bg-secondary);\n        border-radius: 0.25rem;\n\n        .text {\n          color: var(--clr-text-primary);\n        }\n      }\n    }\n  }\n\n  .priority-picker {\n    left: initial;\n    right: 0;\n    top: 70%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
